import { defaultUnits, QuantitiesTypes } from 'common/enums/unit-templates.js';
import { KnowEdmTableValue } from '../interfaces.js';
import { KnowEdmTableData } from './table-enums.js';

const siteReferenceSystemMap = new Map<KnowEdmTableData, KnowEdmTableValue<KnowEdmTableData>>();

siteReferenceSystemMap.set(KnowEdmTableData.GeodeticDatum, {
  key: KnowEdmTableData.GeodeticDatum,
  label: 'Geodetic Datum',
  unit: '',
  quantity: '',
  tooltip: 'entities_geodeticDatumTooltip',
});

siteReferenceSystemMap.set(KnowEdmTableData.MapSystem, {
  key: KnowEdmTableData.MapSystem,
  label: 'Map System',
  unit: '',
  quantity: '',
  tooltip: 'entities_mapSystemTooltip',
});

siteReferenceSystemMap.set(KnowEdmTableData.MapZone, {
  key: KnowEdmTableData.MapZone,
  label: 'Map Zone',
  unit: '',
  quantity: '',
  tooltip: 'entities_mapZoneTooltip',
});

siteReferenceSystemMap.set(KnowEdmTableData.EPSGCode, {
  key: KnowEdmTableData.EPSGCode,
  label: 'EPSG Code',
  unit: '',
  quantity: '',
  tooltip: 'entities_epsgCodeTooltip',
});

siteReferenceSystemMap.set(KnowEdmTableData.EPSGCode, {
  key: KnowEdmTableData.EPSGCode,
  label: 'EPSG Code',
  unit: '',
  quantity: '',
  tooltip: 'entities_epsgCodeTooltip',
});

siteReferenceSystemMap.set(KnowEdmTableData.GeographicalLongitude, {
  key: KnowEdmTableData.GeographicalLongitude,
  label: 'Geographical Longitude',
  unit: defaultUnits.get(QuantitiesTypes.Angle),
  quantity: QuantitiesTypes.Angle,
  tooltip: 'entities_geographicalLongitudeTooltip',
});

siteReferenceSystemMap.set(KnowEdmTableData.GeographicalLatitude, {
  key: KnowEdmTableData.GeographicalLatitude,
  label: 'Geographical Latitude',
  unit: defaultUnits.get(QuantitiesTypes.Angle),
  quantity: QuantitiesTypes.Angle,
  tooltip: 'entities_geographicalLatitudeTooltip',
});

siteReferenceSystemMap.set(KnowEdmTableData.Easting, {
  key: KnowEdmTableData.Easting,
  label: 'Easting',
  unit: defaultUnits.get(QuantitiesTypes.Length),
  quantity: QuantitiesTypes.Location,
  tooltip: 'entities_mapPosititionNSTooltip',
});

siteReferenceSystemMap.set(KnowEdmTableData.Northing, {
  key: KnowEdmTableData.Northing,
  label: 'Northing',
  unit: defaultUnits.get(QuantitiesTypes.Length),
  quantity: QuantitiesTypes.Location,
  tooltip: 'entities_mapPosititionNSTooltip',
});

export {
  siteReferenceSystemMap,
};
